module.exports = __webpack_public_path__ + "img/发展历程@2x.edc0043a.png";